import classNames from 'classnames';
import CustomButton from '../../../components/customButton';
import Activities from '../../../module/shop/lab/activities';
import styles from './selectActivity.module.scss';
import {useLab} from '../../../context/labContext';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {LabActivities} from '../../shop/create/lab/helper/data';
import UseUpdateLabShop from '../hooks/useUpdateLabShop';
import Header from '../../../components/header';

const SelectLabActivity = () => {
  const {updateLab} = UseUpdateLabShop();
  const {updateActivityFiled, lab} = useLab();
  const [selectedLab, setSelectedLab] = useState<Array<ILabActivity>>([
    ...LabActivities.filter(item => lab?.activity_field?.includes(item.code)),
  ]);
  const navigate = useNavigate();
  const handleClick = () => {
    updateActivityFiled({
      activity_field: selectedLab.map(x => x.code),
    });
    navigate('/lab/edit/services', {
      state: {
        activityIds: selectedLab.map(x => x.code).toString(),
      },
    });
  };
  const handleUpdate = () => {
    updateLab({
      guid: lab?.guid || '',
      activity_field: selectedLab.map(item => item.code).toString() || '',
    });
  };
  return (
    <>
      <Header title={'ایجاد آزمایشگاه'} />

      <div
        className={classNames('d-flex flex-column', styles['select-activity'])}
      >
        <div className="flex-grow-1">
          <div className="text-center pt-5">
            <h6 className="color-gray-1">
              زمینه فعالیت آزمایشگاه خود را انتخاب نمایید
            </h6>
          </div>
          <div className="mt-4 px-3">
            <Activities
              selectedLab={selectedLab}
              setSelectedLab={setSelectedLab}
              data={LabActivities}
            />
          </div>
        </div>
        <div className="px-3 d-flex  gap-2">
          <CustomButton
            onClick={handleClick}
            disabled={selectedLab.length === 0}
            className={styles['continue-btn']}
          >
            ادامه
          </CustomButton>
          <CustomButton
            onClick={handleUpdate}
            disabled={selectedLab.length === 0}
          >
            ثبت تغییرات
          </CustomButton>
        </div>
      </div>
    </>
  );
};

export default SelectLabActivity;
